import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const SERVICE_TYPE_PARAM = 'service_type';

/**
 * The profile reads its service from `service_type` on load, so writing the selected
 * service back to the query string keeps it on reload and in a shared link.
 */
export const useUpdateSelectedService = (): ((serviceType: string) => void) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (serviceType: string) => {
      const params = new URLSearchParams(location.search);
      if (params.get(SERVICE_TYPE_PARAM) === serviceType) return;
      params.set(SERVICE_TYPE_PARAM, serviceType);
      navigate({ search: params.toString() }, { replace: true });
    },
    [location.search, navigate]
  );
};
